import { environment } from '../../../../environments/environment';

/**
 * Fonte única da montagem de URL da API de Parametrização.
 *
 * Combina, nesta ordem: `environment.baseUrl` + `environment.apiGatewayPrefix`
 * (segmento do gateway Azure, ex.: `apis`) + `environment.apiParametrizacaoUrl`
 * + o `path` informado. Segmentos vazios são omitidos, então a mesma função serve:
 *
 * - back remoto (HML/prod): `https://homologacao.vivest.com.br/apis/api-perfil-investimento/v1/Campanha`
 * - back local (Kestrel):   `https://localhost:50592/api-perfil-investimento/v1/Campanha`
 *
 * Sem o `${baseUrl}` a URL fica relativa e o browser a resolve contra o host do
 * front (ex.: `perfil-investimento-administrativo-dev...`), gerando 404.
 *
 * `apiUrl` troca o segmento da API — ex.: `environment.apiInstitutoPrevidenciarioUrl` para a API Instituto
 * Online. Sem ele vale `apiParametrizacaoUrl`.
 *
 * Função pura: não valida configuração. Quem precisa falhar quando
 * `apiParametrizacaoUrl` está vazio (ex.: `HttpClientService`) deve checar
 * antes de chamar.
 */
export function buildApiUrl(
  path: string,
  apiUrl: string = environment.apiParametrizacaoUrl,
): string {
  const origin = environment.baseUrl?.trim().replace(/\/+$/, '') ?? '';
  const gatewayPrefix = environment.apiGatewayPrefix?.trim().replace(/^\/+|\/+$/g, '') ?? '';
  const apiSegment = apiUrl?.trim().replace(/^\/+|\/+$/g, '') ?? '';
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  const base = [origin, gatewayPrefix, apiSegment].filter((segment) => segment.length > 0).join('/');

  return `${base}${normalizedPath}`;
}
